var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDirectorio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_directorio",
    transform: "translate(0.008 0.008)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_210",
    "data-name": "Rect\\xE1ngulo 210",
    width: 25,
    height: 25,
    transform: "translate(-0.008 -0.008)",
    fill: "#5a5a5a",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "mUiDKq.tif",
    transform: "translate(5.093 1.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_999",
    "data-name": "Grupo 999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_469",
    "data-name": "Trazado 469",
    d: "M16.748,3.146a.434.434,0,0,1,.206.435c-.011.135,0,.272,0,.435h1.424c.354,0,.46.11.461.471s0,.736,0,1.124h3.676c.352,0,.441.086.441.431V23.768c0,.347-.089.435-.437.435H8.586c-.334,0-.427-.091-.427-.425V8.788a1.1,1.1,0,0,1,0-.144.292.292,0,0,1,.262-.273.285.285,0,0,1,.344.192,1.035,1.035,0,0,1,.036.324q0,7.177,0,14.353v.3H22.3V6.274H18.837c0,.291,0,.577,0,.863,0,.321-.115.439-.43.439q-2.959,0-5.918,0c-.322,0-.425-.108-.425-.434,0-.287,0-.573,0-.873H8.8c0,.279,0,.55,0,.822a.945.945,0,0,1-.03.263.288.288,0,0,1-.334.212.284.284,0,0,1-.276-.282q-.012-.689,0-1.377c0-.188.134-.292.347-.294.424,0,.849,0,1.274,0h2.28c0-.406,0-.795,0-1.183,0-.3.111-.41.406-.412.4,0,.807,0,1.237,0,0-.156.009-.3,0-.438a.414.414,0,0,1,.209-.432ZM18.17,6.922V4.677H12.722V6.922ZM16.282,4.009V3.8H14.368v.2Z",
    transform: "translate(-8.157 -3.146)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_470",
    "data-name": "Trazado 470",
    d: "M20.144,26c-1.123,0-2.246-.008-3.369.006-.278,0-.477-.263-.335-.471a.576.576,0,0,1,.242-.167.532.532,0,0,1,.2-.012q3.257,0,6.513,0a1.138,1.138,0,0,1,.244.019.291.291,0,0,1,.244.33A.3.3,0,0,1,23.6,26c-.068.006-.137,0-.206,0Z",
    transform: "translate(-11.248 -11.48)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_471",
    "data-name": "Trazado 471",
    d: "M20.136,14.848H16.911a1.824,1.824,0,0,1-.185,0,.337.337,0,0,1-.332-.345.322.322,0,0,1,.354-.295q3.39,0,6.78,0a.325.325,0,0,1,.364.307c.006.193-.144.333-.386.335-.617,0-1.233,0-1.849,0Z",
    transform: "translate(-11.248 -7.295)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_472",
    "data-name": "Trazado 472",
    d: "M20.139,31.588q-1.672,0-3.345,0c-.157,0-.3-.038-.345-.2a.384.384,0,0,1,.042-.315.53.53,0,0,1,.34-.135c.492-.014.985-.006,1.477-.006h5.048c.048,0,.1,0,.144,0,.251.005.412.139.407.337s-.159.313-.4.314Z",
    transform: "translate(-11.264 -13.575)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_473",
    "data-name": "Trazado 473",
    d: "M13.875,14.069c0,.28,0,.561,0,.842a.339.339,0,0,1-.378.382q-.83,0-1.662,0a.33.33,0,0,1-.367-.352q-.011-.872,0-1.745a.323.323,0,0,1,.347-.351q.851-.011,1.7,0a.331.331,0,0,1,.356.362C13.879,13.494,13.875,13.782,13.875,14.069Zm-.66-.525H12.121v1.045h1.094Z",
    transform: "translate(-9.397 -6.784)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_474",
    "data-name": "Trazado 474",
    d: "M20.127,20.42H16.9c-.061,0-.123,0-.185,0a.322.322,0,0,1-.324-.3.326.326,0,0,1,.324-.329c.054,0,.109,0,.164,0h6.512c.341,0,.5.1.5.32s-.156.319-.5.319Z",
    transform: "translate(-11.248 -9.389)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_475",
    "data-name": "Trazado 475",
    d: "M13.875,19.76c0,.274,0,.547,0,.821a.333.333,0,0,1-.362.378q-.841.014-1.681,0a.333.333,0,0,1-.365-.377q-.008-.83,0-1.662a.333.333,0,0,1,.373-.365q.83,0,1.66,0c.249,0,.371.127.374.384C13.878,19.213,13.875,19.486,13.875,19.76Zm-1.753.544h1.086V19.217H12.122Z",
    transform: "translate(-9.397 -8.928)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_476",
    "data-name": "Trazado 476",
    d: "M13.875,30.96c0,.267,0,.534,0,.8s-.122.4-.382.4q-.821.008-1.64,0c-.261,0-.384-.132-.387-.4q-.006-.811,0-1.621a.345.345,0,0,1,.394-.39q.81,0,1.62,0c.273,0,.393.128.4.408S13.875,30.693,13.875,30.96Zm-.667.547V30.419H12.123v1.088Z",
    transform: "translate(-9.398 -13.13)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_477",
    "data-name": "Trazado 477",
    d: "M12.674,26.523c-.28,0-.562,0-.842,0a.326.326,0,0,1-.365-.352q-.012-.842,0-1.686a.32.32,0,0,1,.357-.358q.842-.008,1.685,0a.326.326,0,0,1,.365.371q0,.822,0,1.645a.334.334,0,0,1-.377.38C13.222,26.526,12.949,26.523,12.674,26.523Zm.533-.659V24.781H12.122v1.083Z",
    transform: "translate(-9.397 -11.018)",
    fill: "#5a5a5a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDirectorio);
export default __webpack_public_path__ + "static/media/ic_directorio.c477d0a3ceb26efdda619f54df38261a.svg";
export { ForwardRef as ReactComponent };